import { cn } from "@/lib/cn";

const IRIS_TONE = {
  neutral: "bg-card-text/[0.06]",
  primary: "bg-primary/[0.12]",
  secondary: "bg-secondary/[0.12]",
  success: "bg-success/[0.12]",
  warning: "bg-warning/[0.12]",
  danger: "bg-danger/[0.12]",
} as const;

/** Palette of a `SelectionIris` tint. */
export type SelectionIrisTone = keyof typeof IRIS_TONE;

/** Props of `SelectionIris`; `origin` is a CSS position inside the card (from `useSelectionIrisOrigin`). */
export type SelectionIrisProps = {
  selected: boolean;
  origin: string;
  tone?: SelectionIrisTone;
};

/**
 * Selected tint of a card that opens as a circle from the tap point and closes back into it (Iris click, the portal
 * ActionCard's hover iris on tap). The host is `relative isolate` and keeps its own surface at rest.
 */
export function SelectionIris({ selected, origin, tone = "primary" }: SelectionIrisProps) {
  return (
    <span
      aria-hidden
      data-selection-iris
      className={cn(
        "pointer-events-none absolute inset-0 -z-10 rounded-card transition-[clip-path] duration-emphasis ease-enter motion-reduce:transition-none",
        IRIS_TONE[tone],
      )}
      style={{ clipPath: `circle(${selected ? "150%" : "0%"} at ${origin})` }}
    />
  );
}
